import React from 'react';

import { Grid, Section } from '@gogame/components';
import { FormField } from '@gogame/form';

import {
  BANK_NAME,
  BANK_ADDRESS,
  ACCOUNT_NUMBER,
  ACCOUNT_NAME,
  SWIFT_CODE,
  IBAN,
} from '../constants';

const PaymentDetails = ({ name, disabled = false }) => {
  return (
    <Section title={'Payment Details'}>
      <Grid container spacing={3}>
        <Grid item xs={6}>
          <FormField.TextField
            name={`${name}.${BANK_NAME}`}
            label={'Bank name'}
            disabled={disabled}
            padding={0}
            required={true}
          />
        </Grid>
        <Grid item xs={6}>
          <FormField.TextField
            name={`${name}.${BANK_ADDRESS}`}
            label={'Bank address'}
            disabled={disabled}
            padding={0}
            required={true}
          />
        </Grid>

        <Grid item xs={3}>
          <FormField.TextField
            name={`${name}.${ACCOUNT_NUMBER}`}
            label={'Account number'}
            disabled={disabled}
            padding={0}
            required={true}
          />
        </Grid>
        <Grid item xs={3}>
          <FormField.TextField
            name={`${name}.${ACCOUNT_NAME}`}
            label={'Account name'}
            disabled={disabled}
            padding={0}
            required={true}
          />
        </Grid>
        <Grid item xs={3}>
          <FormField.TextField
            name={`${name}.${SWIFT_CODE}`}
            label={'Swift code'}
            disabled={disabled}
            padding={0}
            required={true}
          />
        </Grid>
        <Grid item xs={3}>
          <FormField.TextField
            name={`${name}.${IBAN}`}
            label={'IBAN'}
            disabled={disabled}
            padding={0}
            required={true}
          />
        </Grid>
      </Grid>
    </Section>
  );
};

export default PaymentDetails;
